'use client'

import { Alert, AlertDescription } from '@/components/ui/shadcn/alert'
import { cn } from '@/lib/utils'

export default function ErrorAlerts({
  useGrid,
  message,
  error,
  errors,
  className,
}) {
  const errorsAlert = (
    <Alert variant="destructive" className={cn(className)}>
      <AlertDescription>
        <p>{message}</p>
        {errors?.length > 0 && (
          <ul className="ml-4 mt-1 list-disc">
            {errors.map(e => (
              <li key={e}>{e}</li>
            ))}
          </ul>
        )}
      </AlertDescription>
    </Alert>
  )
  const errorAlert = (
    <Alert variant="destructive" className={cn(className)}>
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  )

  return (
    <>
      {errors && errors.length > 0 && useGrid && (
        <div className="col-span-full">{errorsAlert}</div>
      )}
      {error && useGrid && <div className="col-span-full">{errorAlert}</div>}
      {errors && errors.length > 0 && !useGrid && errorsAlert}
      {error && !useGrid && errorAlert}
    </>
  )
}
